import React, { useState, useCallback, useMemo, useRef } from 'react';
import pump1 from '../assets/canvas/pumps/pump1.png';
import pump2 from '../assets/canvas/pumps/pump2.png';
import pump3 from '../assets/canvas/pumps/pump3.jpg';
import pump4 from '../assets/canvas/pumps/pump4.png';
import pump5 from '../assets/canvas/pumps/pump5.jpg';
import pump6 from '../assets/canvas/pumps/pump6.jpg';
import pump7 from '../assets/canvas/pumps/pump7.png';
import pump8 from '../assets/canvas/pumps/pump8.png';
import pump9 from '../assets/canvas/pumps/pump9.png';
import pump10 from '../assets/canvas/pumps/pump10.png';
import pump11 from '../assets/canvas/pumps/pump11.png';
import pump12 from '../assets/canvas/pumps/pump12.png';
import pump13 from '../assets/canvas/pumps/pump13.png';
import blower1 from '../assets/canvas/blowers/blower1.jpg';
import blower2 from '../assets/canvas/blowers/blower2.jpg';
import blower3 from '../assets/canvas/blowers/blower3.png';
import blower4 from '../assets/canvas/blowers/blower4.png';
import blower5 from '../assets/canvas/blowers/blower5.png';
import belt1 from '../assets/canvas/belt/belt1.avif';
import belt2 from '../assets/canvas/belt/belt2.png';
import belt3 from '../assets/canvas/belt/belt3.png';
import belt4 from '../assets/canvas/belt/belt4.png';
import belt5 from '../assets/canvas/belt/belt5.png';
import belt6 from '../assets/canvas/belt/belt6.png';
import belt7 from '../assets/canvas/belt/belt7.png';
import mechanicalFineScreen from '../assets/canvas/belt/mechnaical_fine_screen-removebg-preview.png';
import agitator1 from '../assets/canvas/agitator/agitator1.png';
import agitator2 from '../assets/canvas/agitator/agitator2.png';
import agitator3 from '../assets/canvas/agitator/agitator3.svg';
import agitator4 from '../assets/canvas/agitator/agitator4.webp';
import agitator5 from '../assets/canvas/agitator/agitator5.png';
import agitator6 from '../assets/canvas/agitator/agitator6.png';
import agitator7 from '../assets/canvas/agitator/agitator7.png';
import agitator8 from '../assets/canvas/agitator/agitator8.png';
import agitator9 from '../assets/canvas/agitator/agitator9.png';
import agitator10 from '../assets/canvas/agitator/agitator10.png';
import agitator11 from '../assets/canvas/agitator/agitator11.png';
import agitator12 from '../assets/canvas/agitator/agitator12.png';
import mixer1 from '../assets/canvas/agitator/mixer1.webp';
import oilSkimmerAgitator from '../assets/canvas/agitator/oil_skimmer-removebg-preview.png';
import switch1 from '../assets/canvas/switches/switch1.png';
import switch2 from '../assets/canvas/switches/switch2.png';
import switch3 from '../assets/canvas/switches/switch3.jpg';
import switch4 from '../assets/canvas/switches/switch4.png';
import switch5 from '../assets/canvas/switches/switch5.png';
import switch6 from '../assets/canvas/switches/switch6.png';
import switch7 from '../assets/canvas/switches/switch7.png';
import switch8 from '../assets/canvas/switches/switch8.webp';
import switch9 from '../assets/canvas/switches/switch9.jpg';
import levelswitch1 from '../assets/canvas/switches/levelswitch1.png';
import valve1 from '../assets/canvas/valve/valve1.png';
import valve2 from '../assets/canvas/valve/valve2.png';
import valve3 from '../assets/canvas/valve/valve3.png';
import valve4 from '../assets/canvas/valve/valve4.png';
import valve5 from '../assets/canvas/valve/valve5.png';
import valve6 from '../assets/canvas/valve/valve6.png';
import valve7 from '../assets/canvas/valve/valve7.png';
import valve8 from '../assets/canvas/valve/valve8.png';
import valve9 from '../assets/canvas/valve/valve9.png';
import valve10 from '../assets/canvas/valve/valve10.png';
import valve11 from '../assets/canvas/valve/valve11.png';
import valve12 from '../assets/canvas/valve/bfv.png';
import valve13 from '../assets/canvas/valve/ball-valve.png';
// Tank images
import aerationtank1 from '../assets/canvas/tank/aerationtank1.png';
import aerationtank2 from '../assets/canvas/tank/aerationtank2.png';
import aerobicdigester1 from '../assets/canvas/tank/aerobicdigester1.png';
import aerobicdigester2 from '../assets/canvas/tank/aerobicdigester2.png';
import aerobicdigester3 from '../assets/canvas/tank/aerobicdigester3.png';
import bagfilter1 from '../assets/canvas/tank/bagfilter1.png';
import centrifugeTank from '../assets/canvas/tank/centrifuge-tank.png';
import chamber from '../assets/canvas/tank/chamber.png';
import clarifier1 from '../assets/canvas/tank/clarifier1.png';
import clarifier2 from '../assets/canvas/tank/clarifier2.png';
import clarifier3 from '../assets/canvas/tank/clarifier3.png';
import container1 from '../assets/canvas/tank/container1.png';
import container2 from '../assets/canvas/tank/container2.png';
import container3 from '../assets/canvas/tank/container3.png';
import container4 from '../assets/canvas/tank/container4.png';
import digester1 from '../assets/canvas/tank/digester1.png';
import digester2 from '../assets/canvas/tank/digester2.png';
import flashmixingtank from '../assets/canvas/tank/flashmixingtank.png';
import generator1 from '../assets/canvas/tank/generator1.png';
import grittank1 from '../assets/canvas/tank/grittank1.png';
import oilskimmer from '../assets/canvas/tank/oilskimmer.png';
import pressureSandFilter from '../assets/canvas/tank/pressure_sand_filter.png';
import primClarifier from '../assets/canvas/tank/prim-clarifier.png';
import psfBfv from '../assets/canvas/tank/PSF_BFV.png';
import rectClarifier from '../assets/canvas/tank/rect-clarifier.png';
import ro from '../assets/canvas/tank/ro.png';
import sintexTank from '../assets/canvas/tank/sintex_tank.png';
import sintexTank1 from '../assets/canvas/tank/sintex_tank1.png';
import sludgeThickner from '../assets/canvas/tank/sludge-thickner.png';
import tank2 from '../assets/canvas/tank/tank2.webp';
import tank3 from '../assets/canvas/tank/tank3.jpg';
import tank4 from '../assets/canvas/tank/tank4.png';
import tank5 from '../assets/canvas/tank/tank5.jpg';
import tank8 from '../assets/canvas/tank/tank8.png';
import tank9 from '../assets/canvas/tank/tank9.png';
import tank10 from '../assets/canvas/tank/tank10.png';
import tank11 from '../assets/canvas/tank/tank11.png';
import tank12 from '../assets/canvas/tank/tank12.png';
import tank13 from '../assets/canvas/tank/tank13.png';
import tank14 from '../assets/canvas/tank/tank14.png';
import tank15 from '../assets/canvas/tank/tank15.png';
import tank16 from '../assets/canvas/tank/tank16.png';
import tank17 from '../assets/canvas/tank/tank17.png';
import tank18 from '../assets/canvas/tank/tank18.png';
import tank19 from '../assets/canvas/tank/tank19.png';
import uf1 from '../assets/canvas/tank/uf1.png';
import ufMembrane from '../assets/canvas/tank/uf-membrane.png';
import waterTank from '../assets/canvas/tank/water tank.png';
import pressureSandFilter2 from '../assets/canvas/tank/pressure_sand_filter-removebg-preview.png';
import rawWaterTank from '../assets/canvas/tank/raw_water_tank-removebg-preview.png';
import gritChamber from '../assets/canvas/tank/grit_chamber-removebg-preview.png';
// Instrument images
import analoggauge from '../assets/canvas/instruments/analoggauge.png';
import digitalindicator1 from '../assets/canvas/instruments/digitalindicator1.png';
import dometer1 from '../assets/canvas/instruments/dometer1.png';
import flowmeter1 from '../assets/canvas/instruments/flowmeter1.png';
import flowmeter2 from '../assets/canvas/instruments/flowmeter2.png';
import flowmeter3 from '../assets/canvas/instruments/flowmeter3.png';
import flowmeter4 from '../assets/canvas/instruments/flowmeter4.png';
import flowmeter5 from '../assets/canvas/instruments/flowmeter5.png';
import leveltransmitter1 from '../assets/canvas/instruments/leveltransmitter1.png';
import leveltransmitter2 from '../assets/canvas/instruments/leveltransmitter2.png';
import leveltransmitter3 from '../assets/canvas/instruments/leveltransmitter3.png';
import pressuregauge1 from '../assets/canvas/instruments/pressuregauge1.png';
import pressuretransmitter1 from '../assets/canvas/instruments/pressuretransmitter1.png';
import turbinemeter1 from '../assets/canvas/instruments/turbinemeter1.png';
import turbinemeter2 from '../assets/canvas/instruments/turbinemeter2.png';
import turbinemeter3 from '../assets/canvas/instruments/turbinemeter3.png';
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  ReactFlowProvider,
  Handle,
  Position,
} from 'reactflow';
import 'reactflow/dist/style.css';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Chip,
  Stack,
  CircularProgress,
  useTheme,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { 
  Close, 
  Refresh, 
  Edit, 
  Visibility, 
  Add,
  Save,
  Undo,
  ExpandMore
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getTelemetryData, saveCanvasLayout, getCanvasLayout } from '../api/apiService';
import { TELEMETRY_LIVE_POLL_MS } from '../constants/telemetry';

// Helper function to get status color
const getStatusColor = (status) => {
  switch (status) {
    case 'On':
    case 'Open':
      return '#4CAF50';
    case 'Off':
    case 'Closed':
      return '#F44336';
    case 'Trip':
    case 'In Transit':
      return '#FF9800';
    default:
      return '#9E9E9E';
  }
};

// Custom node types for different equipment
const EquipmentNode = ({ data }) => {
  const theme = useTheme();

  // Equipment details are accessed directly via data.equipment

  // Get node size styles based on nodeSize property
  const getNodeSizeStyles = (nodeSize) => {
    switch (nodeSize) {
      case 'xsmall':
        return {
          padding: 1,
          minWidth: 80,
          maxWidth: 120,
          fontSize: '0.6rem'
        };
      case 'small':
        return {
          padding: 1.5,
          minWidth: 120,
          maxWidth: 180,
          fontSize: '0.7rem'
        };
      case 'large':
        return {
          padding: 2.5,
          minWidth: 160,
          maxWidth: 250,
          fontSize: '0.85rem'
        };
      case 'xlarge':
        return {
          padding: 3,
          minWidth: 180,
          maxWidth: 300,
          fontSize: '0.9rem'
        };
      default: // medium
        return {
          padding: 2,
          minWidth: 140,
          maxWidth: 220,
          fontSize: '0.8rem'
        };
    }
  };

  const sizeStyles = getNodeSizeStyles(data.nodeSize);

  return (
    <Box
      sx={{
        padding: sizeStyles.padding,
        borderRadius: '12px',
        backgroundColor: theme.palette.background.paper,
        border: `2px solid ${data.nodeColor || getStatusColor(data.status)}`,
        boxShadow: theme.palette.mode === 'dark' ? '0 6px 18px rgba(0,0,0,0.35)' : '0 4px 12px rgba(0,0,0,0.1)',
        minWidth: sizeStyles.minWidth,
        maxWidth: sizeStyles.maxWidth,
        textAlign: 'center',
        position: 'relative',
        fontSize: sizeStyles.fontSize,
        '&:hover': {
          boxShadow: theme.palette.mode === 'dark' ? '0 8px 25px rgba(0,0,0,0.5)' : '0 8px 25px rgba(0,0,0,0.15)',
          transform: 'translateY(-2px)',
          transition: 'all 0.3s ease',
        }
      }}
    >


      {/* Image Display */}
      {data.imageUrl && (
        <Box
          sx={{
            width: '100%',
            height: 'auto',
            minHeight: data.nodeSize === 'xsmall' ? 30 : 60,
            maxHeight: data.nodeSize === 'xsmall' ? 80 : 150,
            borderRadius: '6px',
            overflow: 'visible',
            marginBottom: 0.5,
            border: '1px solid #e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
            position: 'relative'
          }}
        >
          <img
            src={data.imageUrl}
            alt="Equipment"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: data.nodeSize === 'xsmall' ? 80 : 150,
              objectFit: 'contain',
              display: 'block'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            onLoad={(e) => {
              // Adjust node width based on image aspect ratio if needed
              const img = e.target;
              const aspectRatio = img.naturalWidth / img.naturalHeight;
              const maxHeight = data.nodeSize === 'xsmall' ? 80 : 150;
              const calculatedWidth = maxHeight * aspectRatio;
              
              // If calculated width is significantly different from current width, adjust
              if (calculatedWidth > 0 && Math.abs(calculatedWidth - img.offsetWidth) > 20) {
                const nodeElement = img.closest('[data-testid="rf__node"]');
                if (nodeElement) {
                  nodeElement.style.width = `${Math.min(calculatedWidth + 20, 300)}px`;
                }
              }
            }}
          />
        </Box>
      )}

      {/* Equipment Name */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontSize: data.nodeSize === 'xsmall' ? '0.55rem' :
                   data.nodeSize === 'small' ? '0.65rem' : 
                   data.nodeSize === 'large' ? '0.8rem' :
                   data.nodeSize === 'xlarge' ? '0.85rem' : '0.75rem',
          color: theme.palette.text.primary,
          marginBottom: 0.5,
          lineHeight: 1.2,
          marginTop: data.imageUrl ? 0 : 1
        }}
      >
        {data.label}
      </Typography>

      {/* Status Chip or Reading Display */}
      {data.category === 'Instruments' ? (
        // For instruments, show reading and unit
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          marginBottom: 0.5
        }}>
          {data.reading !== null ? (
            <>
              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                  fontWeight: 600,
                  fontSize: data.nodeSize === 'xsmall' ? '0.65rem' :
                           data.nodeSize === 'small' ? '0.75rem' : 
                           data.nodeSize === 'large' ? '1rem' :
                           data.nodeSize === 'xlarge' ? '1.1rem' : '0.9rem',
                  lineHeight: 1.2
                }}
              >
                {data.reading}
              </Typography>
              {data.unit && (
                <Typography
                  variant="caption"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontSize: data.nodeSize === 'xsmall' ? '0.4rem' :
                             data.nodeSize === 'small' ? '0.5rem' : 
                             data.nodeSize === 'large' ? '0.65rem' :
                             data.nodeSize === 'xlarge' ? '0.7rem' : '0.6rem',
                    fontWeight: 500
                  }}
                >
                  {data.unit}
                </Typography>
              )}
            </>
          ) : (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                fontStyle: 'italic',
                fontSize: data.nodeSize === 'xsmall' ? '0.4rem' :
                         data.nodeSize === 'small' ? '0.5rem' : 
                         data.nodeSize === 'large' ? '0.65rem' :
                         data.nodeSize === 'xlarge' ? '0.7rem' : '0.6rem'
              }}
            >
              No data
            </Typography>
          )}
        </Box>
      ) : (
        // For other equipment, show status chip
        <Chip
          label={data.status}
          size="small"
          sx={{
            backgroundColor: getStatusColor(data.status),
            color: '#ffffff',
            fontWeight: 600,
            fontSize: data.nodeSize === 'xsmall' ? '0.45rem' :
                     data.nodeSize === 'small' ? '0.55rem' : 
                     data.nodeSize === 'large' ? '0.7rem' :
                     data.nodeSize === 'xlarge' ? '0.75rem' : '0.65rem',
            height: data.nodeSize === 'xsmall' ? 16 : 
                    data.nodeSize === 'small' ? 18 : 
                    data.nodeSize === 'large' ? 22 : 
                    data.nodeSize === 'xlarge' ? 24 : 20,
            marginBottom: 0.5
          }}
        />
      )}






      
      {/* Connection Handles - Only visible in edit mode */}
      <Handle 
        type="target" 
        position={Position.Top} 
        id="target-top" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />
      <Handle 
        type="target" 
        position={Position.Left} 
        id="target-left" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />
      <Handle 
        type="target" 
        position={Position.Right} 
        id="target-right" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id="source-bottom" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Left} 
        id="source-left" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Right} 
        id="source-right" 
        className="w-3 h-3 bg-blue-500 border-2 border-white" 
      />


    </Box>
  );
};

// SVG Node component with image support
const SvgNode = ({ data }) => {
  // Get node size styles based on nodeSize property (similar to EquipmentNode)
  const getNodeSizeStyles = (nodeSize) => {
    switch (nodeSize) {
      case 'xsmall':
        return {
          padding: 1,
          minWidth: 80,
          maxWidth: 120,
          fontSize: '0.6rem'
        };
      case 'small':
        return {
          padding: 1.5,
          minWidth: 120,
          maxWidth: 180,
          fontSize: '0.7rem'
        };
      case 'large':
        return {
          padding: 2.5,
          minWidth: 160,
          maxWidth: 250,
          fontSize: '0.85rem'
        };
      case 'xlarge':
        return {
          padding: 3,
          minWidth: 180,
          maxWidth: 300,
          fontSize: '0.9rem'
        };
      default: // medium
        return {
          padding: 2,
          minWidth: 140,
          maxWidth: 220,
          fontSize: '0.8rem'
        };
    }
  };

  const sizeStyles = getNodeSizeStyles(data.nodeSize);

  const theme = useTheme();
  
  return (
    <Box
      sx={{
        padding: sizeStyles.padding,
        borderRadius: '12px',
        backgroundColor: theme.palette.background.paper,
        border: `2px solid ${data.nodeColor || theme.palette.brand?.electricViolet || '#9c27b0'}`,
        boxShadow: theme.palette.mode === 'dark' ? '0 6px 18px rgba(0,0,0,0.35)' : '0 4px 12px rgba(0,0,0,0.1)',
        minWidth: sizeStyles.minWidth,
        maxWidth: sizeStyles.maxWidth,
        textAlign: 'center',
        position: 'relative',
        fontSize: sizeStyles.fontSize,
        '&:hover': {
          boxShadow: theme.palette.mode === 'dark' ? '0 8px 25px rgba(0,0,0,0.5)' : '0 8px 25px rgba(0,0,0,0.15)',
          transform: 'translateY(-2px)',
          transition: 'all 0.3s ease',
        }
      }}
    >


      {/* Image Display */}
      {data.imageUrl && (
        <Box
          sx={{
            width: '100%',
            height: 'auto',
            minHeight: 60,
            maxHeight: 150,
            borderRadius: '6px',
            overflow: 'visible',
            marginBottom: 0.5,
            border: `1px solid ${theme.palette.divider}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
            position: 'relative'
          }}
        >
          <img
            src={data.imageUrl}
            alt="SVG Node"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: 150,
              objectFit: 'contain',
              display: 'block'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            onLoad={(e) => {
              // Adjust node width based on image aspect ratio if needed
              const img = e.target;
              const aspectRatio = img.naturalWidth / img.naturalHeight;
              const maxHeight = 150;
              const calculatedWidth = maxHeight * aspectRatio;
              
              // If calculated width is significantly different from current width, adjust
              if (calculatedWidth > 0 && Math.abs(calculatedWidth - img.offsetWidth) > 20) {
                const nodeElement = img.closest('[data-testid="rf__node"]');
                if (nodeElement) {
                  nodeElement.style.width = `${Math.min(calculatedWidth + 20, 300)}px`;
                }
              }
            }}
          />
        </Box>
      )}

      {/* Node Label */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontSize: data.nodeSize === 'small' ? '0.65rem' : 
                   data.nodeSize === 'large' ? '0.8rem' :
                   data.nodeSize === 'xlarge' ? '0.85rem' : '0.75rem',
          color: theme.palette.text.primary,
          marginBottom: 0.5,
          lineHeight: 1.2,
          marginTop: data.imageUrl ? 0 : 1
        }}
      >
        {data.label || 'SVG Node'}
      </Typography>

      {/* Connection Handles */}
      <Handle 
        type="target" 
        position={Position.Top} 
        id="target-top" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="target" 
        position={Position.Bottom} 
        id="target-bottom" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="target" 
        position={Position.Left} 
        id="target-left" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="target" 
        position={Position.Right} 
        id="target-right" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Top} 
        id="source-top" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id="source-bottom" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Left} 
        id="source-left" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />
      <Handle 
        type="source" 
        position={Position.Right} 
        id="source-right" 
        className="w-3 h-3 bg-purple-500 border-2 border-white" 
      />


    </Box>
  );
};

const PlantView = ({ projectId, siteData, onClose }) => {
  const theme = useTheme();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const nodesRef = useRef(nodes);
  nodesRef.current = nodes;
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [loading, setLoading] = useState(true);
  const [, setTelemetryData] = useState({});
  const [lastTelemetryLocalTime, setLastTelemetryLocalTime] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedEdge, setSelectedEdge] = useState(null);
  const [, setColorPickerAnchor] = useState(null);
  const [saving, setSaving] = useState(false);
  const [canvasVersion, setCanvasVersion] = useState('1.0');

  // Get current user for tracking modifications
  const currentUser = useSelector((state) => state.auth.user);
  // Only Admins can enter Edit Mode / add or modify instruments on the plant canvas
  const isAdmin = currentUser?.role === 'Admin';

  // Equipment data from site
  const equipmentData = useMemo(() => {
    if (!siteData) return [];
    
    const equipment = [];
    let xOffset = 100;
    let yOffset = 100;
    const xSpacing = 200;
    const ySpacing = 150;
    
    // Add instruments
    if (siteData.instruments && siteData.instruments.length > 0) {
      siteData.instruments.forEach((instrument, index) => {
        equipment.push({
          id: `instrument-${instrument.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: instrument.instrumentDescription || 'Instrument',
            type: instrument.instrumentType || 'Instrument',
            status: 'Unknown',
            equipment: instrument,
            category: 'Instruments'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add pumps
    if (siteData.pumps && siteData.pumps.length > 0) {
      siteData.pumps.forEach((pump, index) => {
        equipment.push({
          id: `pump-${pump.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: pump.pumpDescription || 'Pump',
            type: 'Pump',
            status: 'Unknown',
            equipment: pump,
            category: 'Pumps'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add blowers
    if (siteData.blowers && siteData.blowers.length > 0) {
      siteData.blowers.forEach((blower, index) => {
        equipment.push({
          id: `blower-${blower.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: blower.blowerDescription || 'Blower',
            type: 'Blower',
            status: 'Unknown',
            equipment: blower,
            category: 'Blowers'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add belts & screens
    if (siteData.beltsScreens && siteData.beltsScreens.length > 0) {
      siteData.beltsScreens.forEach((beltScreen, index) => {
        equipment.push({
          id: `beltscreen-${beltScreen.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: beltScreen.equipmentDescription || 'Belt/Screen',
            type: beltScreen.equipmentType || 'Belt/Screen',
            status: 'Unknown',
            equipment: beltScreen,
            category: 'Belts & Screens'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add agitators & mixers
    if (siteData.agitatorsMixers && siteData.agitatorsMixers.length > 0) {
      siteData.agitatorsMixers.forEach((agitatorMixer, index) => {
        equipment.push({
          id: `agitator-${agitatorMixer.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: agitatorMixer.equipmentDescription || 'Agitator/Mixer',
            type: agitatorMixer.equipmentType || 'Agitator/Mixer',
            status: 'Unknown',
            equipment: agitatorMixer,
            category: 'Agitators & Mixers'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add dosing pumps
    if (siteData.dosingPumps && siteData.dosingPumps.length > 0) {
      siteData.dosingPumps.forEach((dosingPump, index) => {
        equipment.push({
          id: `dosingpump-${dosingPump.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: dosingPump.pumpDescription || 'Dosing Pump',
            type: 'Dosing Pump',
            status: 'Unknown',
            equipment: dosingPump,
            category: 'Dosing Pumps'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add switches
    if (siteData.switches && siteData.switches.length > 0) {
      siteData.switches.forEach((switchItem, index) => {
        equipment.push({
          id: `switch-${switchItem.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: switchItem.switchDescription || 'Switch',
            type: switchItem.switchType || 'Switch',
            status: 'Unknown',
            equipment: switchItem,
            category: 'Switches'
          }
        });
      });
      yOffset += ySpacing;
    }
    
    // Add valves
    if (siteData.valves && siteData.valves.length > 0) {
      siteData.valves.forEach((valve, index) => {
        equipment.push({
          id: `valve-${valve.id || index}`,
          type: 'equipment',
          position: { x: xOffset + (index * xSpacing), y: yOffset },
          data: {
            label: valve.valveDescription || 'Valve',
            type: valve.valveType || 'Valve',
            status: 'Unknown',
            equipment: valve,
            category: 'Valves'
          }
        });
      });
    }
    
    return equipment;
  }, [siteData]);

  // Group equipment by category for accordion display
  const equipmentByCategory = useMemo(() => {
    const grouped = {};
    equipmentData.forEach(node => {
      const category = node.data.category;
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(node);
    });
    return grouped;
  }, [equipmentData]);

  // Check if equipment is already placed on canvas
  const isEquipmentPlaced = useCallback((equipmentId) => {
    return nodes.some(node => {
      // Check if the node represents the same equipment
      const nodeEquipment = node.data.equipment;
      if (!nodeEquipment) return false;
      
      // Get the original equipment from equipmentData
      const originalEquipment = equipmentData.find(eq => eq.id === equipmentId);
      if (!originalEquipment) return false;
      
      // Compare equipment by their unique identifiers
      const originalEq = originalEquipment.data.equipment;
      const nodeEq = node.data.equipment;
      
      // If both have IDs, compare by ID
      if (originalEq.id && nodeEq.id) {
        return originalEq.id === nodeEq.id;
      }
      
      // If both have descriptions, compare by description and type
      if (originalEq.instrumentDescription && nodeEq.instrumentDescription) {
        return originalEq.instrumentDescription === nodeEq.instrumentDescription && 
               originalEq.instrumentType === nodeEq.instrumentType;
      }
      if (originalEq.pumpDescription && nodeEq.pumpDescription) {
        return originalEq.pumpDescription === nodeEq.pumpDescription && 
               originalEq.pumpType === nodeEq.pumpType;
      }
      if (originalEq.blowerDescription && nodeEq.blowerDescription) {
        return originalEq.blowerDescription === nodeEq.blowerDescription && 
               originalEq.blowerType === nodeEq.blowerType;
      }
      if (originalEq.equipmentDescription && nodeEq.equipmentDescription) {
        return originalEq.equipmentDescription === nodeEq.equipmentDescription && 
               originalEq.equipmentType === nodeEq.equipmentType;
      }
      if (originalEq.valveDescription && nodeEq.valveDescription) {
        return originalEq.valveDescription === nodeEq.valveDescription && 
               originalEq.valveType === nodeEq.valveType;
      }
      if (originalEq.switchDescription && nodeEq.switchDescription) {
        return originalEq.switchDescription === nodeEq.switchDescription && 
               originalEq.switchType === nodeEq.switchType;
      }
      
      // Fallback: compare by label and category
      return node.data.label === originalEquipment.data.label && 
             node.data.category === originalEquipment.data.category;
    });
  }, [nodes, equipmentData]);

  // Load canvas layout from database on component mount
  React.useEffect(() => {
    const loadCanvasLayout = async () => {
      if (!projectId) return;

      try {
        setLoading(true);
        const layout = await getCanvasLayout(projectId);
        
        if (layout.nodes && layout.nodes.length > 0) {
          setNodes(layout.nodes);
        }
        
        if (layout.edges && layout.edges.length > 0) {
          setEdges(layout.edges);
        }
        
        setCanvasVersion(layout.version || '1.0');
        setLoading(false);
      } catch (error) {
        console.error('Error loading canvas layout:', error);
        setLoading(false);
      }
    };

    loadCanvasLayout();
  }, [projectId, setNodes, setEdges]);

  // Fetch telemetry data for equipment status (do not list `nodes` in deps — setNodes after
  // fetch would re-run this effect immediately and bypass the 2-minute interval)
  React.useEffect(() => {
    const fetchTelemetryData = async () => {
      const currentNodes = nodesRef.current;
      if (!projectId || !siteData || currentNodes.length === 0) return;

      try {
        const tagIds = [];
        const serverName = siteData?.serverName || 'PLC1';
        const cleanServerName = serverName.replace(`${projectId}_`, '');

        // Collect all tag IDs from current nodes
        currentNodes.forEach(node => {
          const equipment = node.data.equipment;
          if (equipment.onOffTagName) {
            const formattedTagId = `${projectId}_${cleanServerName}:${equipment.onOffTagName}`;
            tagIds.push(formattedTagId);
          }
          if (equipment.tripTagName) {
            const formattedTagId = `${projectId}_${cleanServerName}:${equipment.tripTagName}`;
            tagIds.push(formattedTagId);
          }
          if (equipment.openTagName) {
            const formattedTagId = `${projectId}_${cleanServerName}:${equipment.openTagName}`;
            tagIds.push(formattedTagId);
          }
          if (equipment.closeTagName) {
            const formattedTagId = `${projectId}_${cleanServerName}:${equipment.closeTagName}`;
            tagIds.push(formattedTagId);
          }
          if (equipment.tagNo) {
            const formattedTagId = `${projectId}_${cleanServerName}:${equipment.tagNo}`;
            tagIds.push(formattedTagId);
          }
        });

        if (tagIds.length === 0) return;

        const data = await getTelemetryData(projectId, tagIds);
        const telemetryMap = {};
        data.forEach(item => {
          telemetryMap[item.tagId] = {
            value: item.value,
            timestamp: item.timestamp,
            localTime: item.localTime,
            isoUtc: item.isoUtc,
            deviceLocalTime: item.deviceLocalTime
          };
        });

        setTelemetryData(telemetryMap);

        // Track the latest timestamp from telemetry
        let latestTimestamp = null;
        let latestLocalTime = null;
        data.forEach(item => {
          // Prioritize deviceLocalTime for display, then localTime, then isoUtc
          if (item.deviceLocalTime) {
            if (!latestLocalTime || new Date(item.deviceLocalTime) > new Date(latestLocalTime)) {
              latestLocalTime = item.deviceLocalTime;
            }
          } else if (item.localTime) {
            if (!latestLocalTime || new Date(item.localTime) > new Date(latestLocalTime)) {
              latestLocalTime = item.localTime;
            }
          } else if (item.isoUtc) {
            if (!latestLocalTime || new Date(item.isoUtc) > new Date(latestLocalTime)) {
              latestLocalTime = item.isoUtc;
            }
          }
          if (item.timestamp) {
            if (!latestTimestamp || item.timestamp > latestTimestamp) {
              latestTimestamp = item.timestamp;
            }
          }
        });
        setLastTelemetryLocalTime(latestLocalTime);

        // Update node data with telemetry information
        setNodes(prevNodes => 
          prevNodes.map(node => {
            const equipment = node.data.equipment;
            let status = 'Unknown';
            let reading = null;
            let unit = null;

            // For instruments, get reading and unit from tagNo
            if (node.data.category === 'Instruments' && equipment.tagNo) {
              const tagId = `${projectId}_${cleanServerName}:${equipment.tagNo}`;
              if (telemetryMap[tagId]) {
                reading = telemetryMap[tagId].value;
                unit = equipment.unit || '';
              }
            } else {
              // For other equipment, get status from onOffTagName, tripTagName, etc.
              if (equipment.onOffTagName) {
                const tagId = `${projectId}_${cleanServerName}:${equipment.onOffTagName}`;
                if (telemetryMap[tagId]) {
                  const value = telemetryMap[tagId].value;
                  if (value === '1' || value === 1 || value === 'true' || value === true) {
                    status = 'On';
                  } else if (value === '0' || value === 0 || value === 'false' || value === false) {
                    status = 'Off';
                  }
                }
              }

              if (equipment.openTagName && equipment.closeTagName) {
                const openTagId = `${projectId}_${cleanServerName}:${equipment.openTagName}`;
                const closeTagId = `${projectId}_${cleanServerName}:${equipment.closeTagName}`;
                
                if (telemetryMap[openTagId] && telemetryMap[closeTagId]) {
                  const openValue = telemetryMap[openTagId].value;
                  const closeValue = telemetryMap[closeTagId].value;
                  
                  if (openValue === '1' || openValue === 1 || openValue === 'true' || openValue === true) {
                    status = 'Open';
                  } else if (closeValue === '1' || closeValue === 1 || closeValue === 'true' || closeValue === true) {
                    status = 'Closed';
                  } else if (openValue === '0' && closeValue === '0') {
                    status = 'In Transit';
                  }
                }
              }
            }

            return {
              ...node,
              data: {
                ...node.data,
                status,
                reading,
                unit
              }
            };
          })
        );
      } catch (error) {
        console.error('Error fetching telemetry data:', error);
      }
    };

    fetchTelemetryData();

    const intervalId = setInterval(fetchTelemetryData, TELEMETRY_LIVE_POLL_MS);
    return () => clearInterval(intervalId);
  }, [projectId, siteData, nodes.length, setNodes]);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  const nodeTypes = useMemo(() => ({
    equipment: EquipmentNode,
    svg: SvgNode,
  }), []);

  // Edit mode functions
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const data = event.dataTransfer.getData('application/reactflow');
      const position = reactFlowInstance.screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });

      try {
        // Parse as JSON (for database equipment and tools)
        const parsedData = JSON.parse(data);
        
        if (parsedData.type === 'node') {
          // Handle database equipment and tool node creation
          const newNode = {
            id: `node-${Date.now()}`,
            type: parsedData.nodeType || 'equipment',
            position,
            data: {
              label: parsedData.data.label,
              type: parsedData.data.type,
              status: parsedData.data.status || 'Unknown',
              equipment: parsedData.data.equipment || {
                id: Date.now(),
                description: parsedData.data.label,
                type: parsedData.data.type,
              },
              category: parsedData.data.category || 'Generic',
              imageUrl: parsedData.data.imageUrl || '',
              nodeColor: parsedData.data.nodeColor || ''
            }
          };
          setNodes((nds) => nds.concat(newNode));
        }
      } catch (error) {
        console.error('Error parsing dropped data:', error);
        // Only database equipment is supported now
      }
    },
    [reactFlowInstance, setNodes]
  );

  const onNodeDragStop = useCallback(
    (event, node) => {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === node.id) {
            return {
              ...n,
              position: node.position,
            };
          }
          return n;
        })
      );
    },
    [setNodes]
  );

  const onNodesDelete = useCallback(
    (deleted) => {
      setNodes((nds) => nds.filter((node) => !deleted.some((d) => d.id === node.id)));
    },
    [setNodes]
  );

  const onEdgesDelete = useCallback(
    (deleted) => {
      setEdges((eds) => eds.filter((edge) => !deleted.some((d) => d.id === edge.id)));
    },
    [setEdges]
  );

  // Handle node selection
  const onNodeClick = useCallback((event, node) => {
    setSelectedNode(node);
    setSelectedEdge(null);
  }, []);

  // Handle edge selection
  const onEdgeClick = useCallback((event, edge) => {
    setSelectedEdge(edge);
    setSelectedNode(null);
  }, []);

  // Handle canvas click to deselect nodes and edges
  const onPaneClick = useCallback(() => {
    setSelectedNode(null);
    setSelectedEdge(null);
  }, []);

  // Predefined colors for nodes
  const nodeColors = [
    '#1976d2', // Blue
    '#2e7d32', // Green
    '#d32f2f', // Red
    '#ed6c02', // Orange
    '#9c27b0', // Purple
    '#1565c0', // Dark Blue
    '#388e3c', // Dark Green
    '#c62828', // Dark Red
    '#ef6c00', // Dark Orange
    '#7b1fa2', // Dark Purple
    '#ff9800', // Light Orange
    '#4caf50', // Light Green
    '#2196f3', // Light Blue
    '#e91e63', // Pink
    '#795548', // Brown
    '#607d8b', // Blue Grey
  ];

  // Predefined colors for edges
  const edgeColors = [
    '#1976d2', // Blue
    '#2e7d32', // Green
    '#d32f2f', // Red
    '#ed6c02', // Orange
    '#9c27b0', // Purple
    '#1565c0', // Dark Blue
    '#388e3c', // Dark Green
    '#c62828', // Dark Red
    '#ef6c00', // Dark Orange
    '#7b1fa2', // Dark Purple
    '#ff9800', // Light Orange
    '#4caf50', // Light Green
    '#2196f3', // Light Blue
    '#e91e63', // Pink
    '#795548', // Brown
    '#607d8b', // Blue Grey
    '#000000', // Black
    '#666666', // Gray
  ];

  // Edge styles
  const edgeStyles = [
    { label: 'Solid', value: 'solid' },
    { label: 'Dashed', value: 'dashed' },
    { label: 'Dotted', value: 'dotted' },
    { label: 'Double', value: 'double' }
  ];

  // Edge path types
  const edgePathTypes = [
    { label: 'Bezier', value: 'bezier' },
    { label: 'Simple Bezier', value: 'simplebezier' },
    { label: 'Smooth Step', value: 'smoothstep' },
    { label: 'Straight', value: 'straight' }
  ];

  // Edge thickness options
  const edgeThicknesses = [
    { label: 'Thin', value: 1 },
    { label: 'Normal', value: 2 },
    { label: 'Thick', value: 3 },
    { label: 'Extra Thick', value: 4 },
    { label: 'Very Thick', value: 6 },
    { label: 'Ultra Thick', value: 8 },
    { label: 'Maximum', value: 12 }
  ];

  // Node size options - include Extra Small for instruments, switches, and valves
  const nodeSizes = [
    ...(selectedNode?.data?.category === 'Instruments' || 
        selectedNode?.data?.category === 'Switches' || 
        selectedNode?.data?.category === 'Valves' ? 
        [{ label: 'Extra Small', value: 'xsmall' }] : []),
    { label: 'Small', value: 'small' },
    { label: 'Medium', value: 'medium' },
    { label: 'Large', value: 'large' },
    { label: 'Extra Large', value: 'xlarge' }
  ];

  // Handle node size selection
  const handleNodeSizeSelect = useCallback((size) => {
    if (selectedNode) {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === selectedNode.id) {
            return {
              ...n,
              data: {
                ...n.data,
                nodeSize: size
              }
            };
          }
          return n;
        })
      );
      // Update selectedNode immediately for real-time UI feedback
      setSelectedNode(prev => prev ? {
        ...prev,
        data: {
          ...prev.data,
          nodeSize: size
        }
      } : null);
    }
  }, [selectedNode, setNodes]);

  // Handle node color selection
  const handleNodeColorSelect = useCallback((color) => {
    if (selectedNode) {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === selectedNode.id) {
            return {
              ...n,
              data: {
                ...n.data,
                nodeColor: color
              }
            };
          }
          return n;
        })
      );
    }
    setColorPickerAnchor(null);
  }, [selectedNode, setNodes]);

  // Handle edge color selection
  const handleEdgeColorSelect = useCallback((color) => {
    if (selectedEdge) {
      setEdges((eds) =>
        eds.map((e) => {
          if (e.id === selectedEdge.id) {
            return {
              ...e,
              style: {
                ...e.style,
                stroke: color
              }
            };
          }
          return e;
        })
      );
      // Update selectedEdge immediately for real-time UI feedback
      setSelectedEdge(prev => prev ? {
        ...prev,
        style: {
          ...prev.style,
          stroke: color
        }
      } : null);
    }
  }, [selectedEdge, setEdges]);

  // Handle edge style selection
  const handleEdgeStyleSelect = useCallback((style) => {
    if (selectedEdge) {
      const strokeDasharray = style === 'solid' ? undefined : 
                              style === 'dashed' ? '5,5' : 
                              style === 'dotted' ? '2,2' : 
                              style === 'double' ? '0,10' : undefined;
      
      setEdges((eds) =>
        eds.map((e) => {
          if (e.id === selectedEdge.id) {
            return {
              ...e,
              style: {
                ...e.style,
                strokeDasharray
              }
            };
          }
          return e;
        })
      );
      // Update selectedEdge immediately for real-time UI feedback
      setSelectedEdge(prev => prev ? {
        ...prev,
        style: {
          ...prev.style,
          strokeDasharray
        }
      } : null);
    }
  }, [selectedEdge, setEdges]);

  // Handle edge thickness selection
  const handleEdgeThicknessSelect = useCallback((thickness) => {
    if (selectedEdge) {
      setEdges((eds) =>
        eds.map((e) => {
          if (e.id === selectedEdge.id) {
            return {
              ...e,
              style: {
                ...e.style,
                strokeWidth: thickness
              }
            };
          }
          return e;
        })
      );
      // Update selectedEdge immediately for real-time UI feedback
      setSelectedEdge(prev => prev ? {
        ...prev,
        style: {
          ...prev.style,
          strokeWidth: thickness
        }
      } : null);
    }
  }, [selectedEdge, setEdges]);

  // Handle edge path type selection
  const handleEdgePathTypeSelect = useCallback((pathType) => {
    if (selectedEdge) {
      setEdges((eds) =>
        eds.map((e) => {
          if (e.id === selectedEdge.id) {
            return {
              ...e,
              type: pathType
            };
          }
          return e;
        })
      );
      // Update selectedEdge immediately for real-time UI feedback
      setSelectedEdge(prev => prev ? {
        ...prev,
        type: pathType
      } : null);
    }
  }, [selectedEdge, setEdges]);

  // Handle edge animation toggle
  const handleEdgeAnimationToggle = useCallback(() => {
    if (selectedEdge) {
      const newAnimatedState = !selectedEdge.animated;
      setEdges((eds) =>
        eds.map((e) => {
          if (e.id === selectedEdge.id) {
            return {
              ...e,
              animated: newAnimatedState
            };
          }
          return e;
        })
      );
      // Update selectedEdge immediately for real-time UI feedback
      setSelectedEdge(prev => prev ? {
        ...prev,
        animated: newAnimatedState
      } : null);
    }
  }, [selectedEdge, setEdges]);

  const handleSave = useCallback(async () => {
    if (!projectId) return;

    try {
      setSaving(true);
      
      const canvasData = {
        nodes,
        edges,
        version: canvasVersion,
        modifiedBy: currentUser?.email || 'unknown'
      };

      await saveCanvasLayout(projectId, canvasData);
      
      // Show success feedback
      console.log('Canvas layout saved successfully!');
      setIsEditMode(false);
    } catch (error) {
      console.error('Error saving canvas layout:', error);
      // You might want to show an error message to the user here
    } finally {
      setSaving(false);
    }
  }, [projectId, nodes, edges, canvasVersion, currentUser]);

  const handleCancel = useCallback(async () => {
    try {
      // Reload the original layout from database
      const layout = await getCanvasLayout(projectId);
      
      if (layout.nodes && layout.nodes.length > 0) {
        setNodes(layout.nodes);
      } else {
        setNodes([]);
      }
      
      if (layout.edges && layout.edges.length > 0) {
        setEdges(layout.edges);
      } else {
        setEdges([]);
      }
      
      setIsEditMode(false);
    } catch (error) {
      console.error('Error reloading canvas layout:', error);
      // Reset to empty canvas if reload fails
      setNodes([]);
      setEdges([]);
      setIsEditMode(false);
    }
  }, [projectId, setNodes, setEdges]);

  if (loading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.palette.background.default,
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          padding: '16px 24px'
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
            Plant View - {siteData?.id || projectId}
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ color: theme.palette.text.secondary }}>
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <CircularProgress sx={{ color: theme.palette.brand?.royalBlue || theme.palette.primary.main }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.palette.background.default,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        padding: '16px 24px',
        minHeight: '64px',
        boxShadow: theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.2)' : '0 2px 4px rgba(0,0,0,0.05)'
      }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
            {isEditMode ? 'Edit Plant Canvas' : 'Plant View'} - {siteData?.id || projectId}
          </Typography>
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mt: 0.5 }}>
            {isEditMode ? 'Design and arrange your plant layout' : siteData?.name || 'Plant Layout'}
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 0.25, display: 'block' }}>
            Last Telemetry: {lastTelemetryLocalTime ? lastTelemetryLocalTime : '—'}
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Mode Toggle Buttons - Admin only. Users get view-only access, no edit/add controls. */}
          {isAdmin && (
            <ToggleButtonGroup
              value={isEditMode ? 'edit' : 'view'}
              exclusive
              onChange={(event, newMode) => {
                if (newMode !== null && isAdmin) {
                  setIsEditMode(newMode === 'edit');
                }
              }}
              size="small"
              sx={{
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                borderRadius: '6px',
                '& .MuiToggleButton-root': {
                  px: 2,
                  py: 0.5,
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  border: `1px solid ${theme.palette.divider}`,
                  color: theme.palette.text.primary,
                  '&.Mui-selected': {
                    backgroundColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: theme.palette.mode === 'dark' 
                        ? alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, 0.85)
                        : alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, 0.90),
                    }
                  },
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                  }
                }
              }}
            >
              <ToggleButton value="view">
                <Visibility sx={{ mr: 0.5, fontSize: 14 }} />
                View
              </ToggleButton>
              <ToggleButton value="edit">
                <Edit sx={{ mr: 0.5, fontSize: 14 }} />
                Edit
              </ToggleButton>
            </ToggleButtonGroup>
          )}

          {!isEditMode && (
            <IconButton 
              size="small" 
              sx={{ 
                color: theme.palette.text.secondary,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                  color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                }
              }}
            >
              <Refresh />
            </IconButton>
          )}
          
          {/* Edit Mode Controls */}
          {isEditMode && (
            <>
              <Tooltip title="Save Layout">
                <IconButton 
                  size="small" 
                  onClick={handleSave}
                  disabled={saving}
                  sx={{ 
                    color: theme.palette.brand?.jade || theme.palette.success.main,
                    backgroundColor: alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.24 : 0.16),
                    },
                    '&:disabled': {
                      color: theme.palette.text.disabled,
                      backgroundColor: alpha(theme.palette.text.secondary, theme.palette.mode === 'dark' ? 0.08 : 0.05),
                    }
                  }}
                >
                  {saving ? <CircularProgress size={16} color="inherit" /> : <Save />}
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel Changes">
                <IconButton 
                  size="small" 
                  onClick={handleCancel} 
                  sx={{ 
                    color: theme.palette.error.main,
                    backgroundColor: alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.24 : 0.16),
                    }
                  }}
                >
                  <Undo />
                </IconButton>
              </Tooltip>
            </>
          )}
          
          <IconButton 
            onClick={onClose} 
            size="small" 
            sx={{ 
              color: theme.palette.text.secondary,
              '&:hover': {
                backgroundColor: alpha(theme.palette.text.secondary, theme.palette.mode === 'dark' ? 0.12 : 0.08),
              }
            }}
          >
            <Close />
          </IconButton>
        </Stack>
      </Box>
      
      <Box sx={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ 
          height: '100%', 
          width: '100%', 
          position: 'relative',
          display: 'flex'
        }}>



          {/* Equipment Palette Side Dock for Edit Mode */}
          {isEditMode && (
            <Box sx={{ 
              width: 280,
              backgroundColor: theme.palette.background.paper,
              borderRight: `1px solid ${theme.palette.divider}`,
              boxShadow: theme.palette.mode === 'dark' ? '2px 0 8px rgba(0,0,0,0.3)' : '2px 0 8px rgba(0,0,0,0.1)',
              display: 'flex',
              flexDirection: 'column',
              flexShrink: 0,
              overflow: 'hidden'
            }}>

              {/* Tools Section */}
              <Box sx={{ 
                padding: '16px 20px',
                borderBottom: `1px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50]
              }}>
                <Typography variant="subtitle2" sx={{ 
                  fontWeight: 600, 
                  mb: 2, 
                  color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                  fontSize: '0.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Tools
                </Typography>
                <Stack spacing={1}>
                  <Box
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.setData('application/reactflow', JSON.stringify({
                        type: 'node',
                        nodeType: 'equipment',
                        data: {
                          label: 'New Node',
                          type: 'Generic',
                          status: 'Unknown',
                          equipment: {
                            id: Date.now(),
                            description: 'New Node',
                            type: 'Generic',
                          }
                        }
                      }));
                    }}
                    sx={{
                      padding: '8px 12px',
                      border: `1px solid ${theme.palette.brand?.royalBlue || theme.palette.primary.main}`,
                      borderRadius: '4px',
                      backgroundColor: theme.palette.background.paper,
                      color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                      cursor: 'grab',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                        borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                        transform: 'translateY(-1px)',
                        boxShadow: theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
                      },
                      '&:active': {
                        cursor: 'grabbing',
                        transform: 'translateY(0)',
                      }
                    }}
                  >
                    <Add sx={{ fontSize: '1rem' }} />
                    Add Node
                  </Box>
                  
                  <Box
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.setData('application/reactflow', JSON.stringify({
                        type: 'node',
                        nodeType: 'svg',
                        data: {
                          label: 'SVG Node',
                          imageUrl: '',
                          type: 'SVG'
                        }
                      }));
                    }}
                    sx={{
                      padding: '8px 12px',
                      border: `1px solid ${theme.palette.brand?.electricViolet || theme.palette.secondary.main}`,
                      borderRadius: '4px',
                      backgroundColor: theme.palette.background.paper,
                      color: theme.palette.brand?.electricViolet || theme.palette.secondary.main,
                      cursor: 'grab',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.brand?.electricViolet || theme.palette.secondary.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                        borderColor: theme.palette.brand?.electricViolet || theme.palette.secondary.main,
                        transform: 'translateY(-1px)',
                        boxShadow: theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
                      },
                      '&:active': {
                        cursor: 'grabbing',
                        transform: 'translateY(0)',
                      }
                    }}
                  >
                    <Box
                      component="svg"
                      sx={{
                        width: '1rem',
                        height: '1rem',
                        fill: 'currentColor'
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5zM12 15.99c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                    </Box>
                    Add SVG Node
                  </Box>
                </Stack>
              </Box>

              {/* Edit Node Toolbar */}
              {selectedNode && (
                <Box sx={{ 
                  padding: '16px 20px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? alpha(theme.palette.brand?.gold || theme.palette.warning.main, 0.08)
                    : alpha(theme.palette.brand?.gold || theme.palette.warning.main, 0.05),
                  maxHeight: '300px',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[100],
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400],
                    borderRadius: '3px',
                    '&:hover': {
                      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[500],
                    },
                  },
                }}>
                  <Typography variant="subtitle2" sx={{ 
                    fontWeight: 600, 
                    mb: 2, 
                    color: theme.palette.brand?.gold || theme.palette.warning.main,
                    fontSize: '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    Edit Node
                  </Typography>
                  
                  <Stack spacing={2}>
                    {/* Node Info */}
                    <Box sx={{ 
                      padding: '12px',
                      backgroundColor: theme.palette.background.paper,
                      borderRadius: '8px',
                      border: `1px solid ${alpha(theme.palette.brand?.gold || theme.palette.warning.main, 0.3)}`
                    }}>
                      <Typography variant="body2" sx={{ 
                        fontWeight: 600, 
                        color: theme.palette.brand?.gold || theme.palette.warning.main,
                        fontSize: '0.8rem',
                        mb: 1
                      }}>
                        {selectedNode.data.label || 'Node'}
                      </Typography>
                      <Typography variant="caption" sx={{ 
                        color: theme.palette.text.secondary,
                        fontSize: '0.7rem'
                      }}>
                        Type: {selectedNode.data.type || 'Unknown'} • ID: {selectedNode.id}
                      </Typography>
                    </Box>

                    {/* Edit Fields */}
                    <Stack spacing={1.5}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Node Label"
                        value={selectedNode.data.label || ''}
                        onChange={(e) => {
                          setNodes((nds) =>
                            nds.map((n) => {
                              if (n.id === selectedNode.id) {
                                return {
                                  ...n,
                                  data: {
                                    ...n.data,
                                    label: e.target.value
                                  }
                                };
                              }
                              return n;
                            })
                          );
                          // Update selectedNode immediately for real-time UI feedback
                          setSelectedNode(prev => prev ? {
                            ...prev,
                            data: {
                              ...prev.data,
                              label: e.target.value
                            }
                          } : null);
                        }}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            fontSize: '0.8rem',
                            backgroundColor: theme.palette.background.paper,
                            '&:hover fieldset': {
                              borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                            },
                          },
                          '& .MuiInputLabel-root.Mui-focused': {
                            color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                          },
                        }}
                      />

                      {selectedNode.type === 'equipment' && (
                        <FormControl fullWidth size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={selectedNode.data.status || 'Unknown'}
                            onChange={(e) => {
                              setNodes((nds) =>
                                nds.map((n) => {
                                  if (n.id === selectedNode.id) {
                                    return {
                                      ...n,
                                      data: {
                                        ...n.data,
                                        status: e.target.value
                                      }
                                    };
                                  }
                                  return n;
                                })
                              );
                              // Update selectedNode immediately for real-time UI feedback
                              setSelectedNode(prev => prev ? {
                                ...prev,
                                data: {
                                  ...prev.data,
                                  status: e.target.value
                                }
                              } : null);
                            }}
                            label="Status"
                            sx={{
                              fontSize: '0.8rem'
                            }}
                          >
                            <MenuItem value="Unknown">Unknown</MenuItem>
                            <MenuItem value="On">On</MenuItem>
                            <MenuItem value="Off">Off</MenuItem>
                            <MenuItem value="Open">Open</MenuItem>
                            <MenuItem value="Closed">Closed</MenuItem>
                            <MenuItem value="Trip">Trip</MenuItem>
                            <MenuItem value="In Transit">In Transit</MenuItem>
                          </Select>
                        </FormControl>
                      )}

                      {/* Pump Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Pumps' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Pump Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: 1,
                            maxHeight: '120px',
                            overflowY: 'auto'
                          }}>
                            {[
                              pump1,
                              pump2,
                              pump3,
                              pump4,
                              pump5,
                              pump6,
                              pump7,
                              pump8,
                              pump9,
                              pump10,
                              pump11,
                              pump12,
                              pump13
                            ].map((pumpImage, index) => (
                              <Box
                                key={pumpImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: pumpImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: pumpImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === pumpImage ? (theme.palette.brand?.royalBlue || theme.palette.primary.main) : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={pumpImage}
                                  alt={`Pump ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Pump {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Blower Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Blowers' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Blower Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(2, 1fr)', 
                            gap: 1,
                            maxHeight: '80px',
                            overflowY: 'auto'
                          }}>
                            {[
                              blower1,
                              blower2,
                              blower3,
                              blower4,
                              blower5
                            ].map((blowerImage, index) => (
                              <Box
                                key={blowerImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: blowerImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: blowerImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === blowerImage ? (theme.palette.brand?.electricViolet || theme.palette.secondary.main) : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.brand?.electricViolet || theme.palette.secondary.main,
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={blowerImage}
                                  alt={`Blower ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Blower {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Belt & Screens Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Belts & Screens' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Belt & Screen Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(2, 1fr)', 
                            gap: 1,
                            maxHeight: '80px',
                            overflowY: 'auto'
                          }}>
                            {[
                              belt1,
                              belt2,
                              belt3,
                              belt4,
                              belt5,
                              belt6,
                              belt7,
                              mechanicalFineScreen
                            ].map((beltImage, index) => (
                              <Box
                                key={beltImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: beltImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: beltImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === beltImage ? theme.palette.accents?.slate || '#795548' : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.accents?.slate || '#795548',
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={beltImage}
                                  alt={`Belt ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Belt {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Agitators & Mixers Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Agitators & Mixers' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Agitator & Mixer Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(3, 1fr)', 
                            gap: 1,
                            maxHeight: '120px',
                            overflowY: 'auto'
                          }}>
                            {[
                              agitator1,
                              agitator2,
                              agitator3,
                              agitator4,
                              agitator5,
                              agitator6,
                              agitator7,
                              agitator8,
                              agitator9,
                              agitator10,
                              agitator11,
                              agitator12,
                              mixer1,
                              oilSkimmerAgitator
                            ].map((agitatorImage, index) => (
                              <Box
                                key={agitatorImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: agitatorImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: agitatorImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === agitatorImage ? theme.palette.accents?.slate || '#607D8B' : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.accents?.slate || '#607D8B',
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={agitatorImage}
                                  alt={`Agitator ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  {index < 4 ? `Agitator ${index + 1}` : 'Mixer 1'}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Switches Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Switches' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Switch Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: 1,
                            maxHeight: '120px',
                            overflowY: 'auto'
                          }}>
                            {[
                              switch1,
                              switch2,
                              switch3,
                              switch4,
                              switch5,
                              switch6,
                              switch7,
                              switch8,
                              switch9,
                              levelswitch1
                            ].map((switchImage, index) => (
                              <Box
                                key={switchImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: switchImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: switchImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === switchImage ? (theme.palette.brand?.royalBlue || theme.palette.primary.main) : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={switchImage}
                                  alt={`Switch ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Switch {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Valves Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Valves' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Valve Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(2, 1fr)', 
                            gap: 1,
                            maxHeight: '80px',
                            overflowY: 'auto'
                          }}>
                            {[
                              valve1,
                              valve2,
                              valve3,
                              valve4,
                              valve5,
                              valve6,
                              valve7,
                              valve8,
                              valve9,
                              valve10,
                              valve11,
                              valve12,
                              valve13
                            ].map((valveImage, index) => (
                              <Box
                                key={valveImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: valveImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: valveImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === valveImage ? theme.palette.accents?.teal || '#009688' : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.accents?.teal || '#009688',
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={valveImage}
                                  alt={`Valve ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Valve {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Dosing Pumps Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Dosing Pumps' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Dosing Pump Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: 1,
                            maxHeight: '120px',
                            overflowY: 'auto'
                          }}>
                            {[
                              pump1,
                              pump2,
                              pump3,
                              pump4,
                              pump5,
                              pump6,
                              pump7,
                              pump8,
                              pump9,
                              pump10,
                              pump11,
                              pump12,
                              pump13
                            ].map((pumpImage, index) => (
                              <Box
                                key={pumpImage}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: pumpImage
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: pumpImage
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === pumpImage ? theme.palette.accents?.rose || '#E91E63' : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.accents?.rose || '#E91E63',
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={pumpImage}
                                  alt={`Dosing Pump ${index + 1}`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  Dosing Pump {index + 1}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* SVG Node Image Selector */}
                      {selectedNode.type === 'svg' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Tank Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: 1,
                            maxHeight: '200px',
                            overflowY: 'auto'
                          }}>
                            {[
                              { image: aerationtank1, name: 'Aeration Tank 1' },
                              { image: aerationtank2, name: 'Aeration Tank 2' },
                              { image: aerobicdigester1, name: 'Aerobic Digester 1' },
                              { image: aerobicdigester2, name: 'Aerobic Digester 2' },
                              { image: aerobicdigester3, name: 'Aerobic Digester 3' },
                              { image: bagfilter1, name: 'Bag Filter 1' },
                              { image: centrifugeTank, name: 'Centrifuge Tank' },
                              { image: chamber, name: 'Chamber' },
                              { image: clarifier1, name: 'Clarifier 1' },
                              { image: clarifier2, name: 'Clarifier 2' },
                              { image: clarifier3, name: 'Clarifier 3' },
                              { image: container1, name: 'Container 1' },
                              { image: container2, name: 'Container 2' },
                              { image: container3, name: 'Container 3' },
                              { image: container4, name: 'Container 4' },
                              { image: digester1, name: 'Digester 1' },
                              { image: digester2, name: 'Digester 2' },
                              { image: flashmixingtank, name: 'Flash Mixing Tank' },
                              { image: generator1, name: 'Generator 1' },
                              { image: gritChamber, name: 'Grit Chamber' },
                              { image: grittank1, name: 'Grit Tank 1' },
                              { image: oilskimmer, name: 'Oil Skimmer' },
                              { image: pressureSandFilter, name: 'Pressure Sand Filter' },
                              { image: pressureSandFilter2, name: 'Pressure Sand Filter 2' },
                              { image: rawWaterTank, name: 'Raw Water Tank' },
                              { image: primClarifier, name: 'Primary Clarifier' },
                              { image: psfBfv, name: 'PSF BFV' },
                              { image: rectClarifier, name: 'Rectangular Clarifier' },
                              { image: ro, name: 'RO' },
                              { image: sintexTank, name: 'Sintex Tank' },
                              { image: sintexTank1, name: 'Sintex Tank 1' },
                              { image: sludgeThickner, name: 'Sludge Thickener' },
                              { image: tank2, name: 'Tank 2' },
                              { image: tank3, name: 'Tank 3' },
                              { image: tank4, name: 'Tank 4' },
                              { image: tank5, name: 'Tank 5' },
                              { image: tank8, name: 'Tank 8' },
                              { image: tank9, name: 'Tank 9' },
                              { image: tank10, name: 'Tank 10' },
                              { image: tank11, name: 'Tank 11' },
                              { image: tank12, name: 'Tank 12' },
                              { image: tank13, name: 'Tank 13' },
                              { image: tank14, name: 'Tank 14' },
                              { image: tank15, name: 'Tank 15' },
                              { image: tank16, name: 'Tank 16' },
                              { image: tank17, name: 'Tank 17' },
                              { image: tank18, name: 'Tank 18' },
                              { image: tank19, name: 'Tank 19' },
                              { image: uf1, name: 'UF 1' },
                              { image: ufMembrane, name: 'UF Membrane' },
                              { image: waterTank, name: 'Water Tank' }
                            ].map((tankImage, index) => (
                              <Box
                                key={tankImage.image}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: tankImage.image
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: tankImage.image
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === tankImage.image ? (theme.palette.brand?.electricViolet || theme.palette.secondary.main) : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.brand?.electricViolet || theme.palette.secondary.main,
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={tankImage.image}
                                  alt={tankImage.name}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  {tankImage.name}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}

                      {/* Instrument Image Selector */}
                      {selectedNode.type === 'equipment' && selectedNode.data.category === 'Instruments' && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" sx={{ 
                            color: '#666',
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            display: 'block',
                            mb: 1
                          }}>
                            Select Instrument Image
                          </Typography>
                          <Box sx={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(4, 1fr)', 
                            gap: 1,
                            maxHeight: '200px',
                            overflowY: 'auto'
                          }}>
                            {[
                              { image: analoggauge, name: 'Analog Gauge' },
                              { image: digitalindicator1, name: 'Digital Indicator' },
                              { image: dometer1, name: 'Dometer' },
                              { image: flowmeter1, name: 'Flow Meter 1' },
                              { image: flowmeter2, name: 'Flow Meter 2' },
                              { image: flowmeter3, name: 'Flow Meter 3' },
                              { image: flowmeter4, name: 'Flow Meter 4' },
                              { image: flowmeter5, name: 'Flow Meter 5' },
                              { image: leveltransmitter1, name: 'Level Transmitter 1' },
                              { image: leveltransmitter2, name: 'Level Transmitter 2' },
                              { image: leveltransmitter3, name: 'Level Transmitter 3' },
                              { image: pressuregauge1, name: 'Pressure Gauge' },
                              { image: pressuretransmitter1, name: 'Pressure Transmitter' },
                              { image: turbinemeter1, name: 'Turbine Meter 1' },
                              { image: turbinemeter2, name: 'Turbine Meter 2' },
                              { image: turbinemeter3, name: 'Turbine Meter 3' }
                            ].map((instrumentImage, index) => (
                              <Box
                                key={instrumentImage.image}
                                onClick={() => {
                                  setNodes((nds) =>
                                    nds.map((n) => {
                                      if (n.id === selectedNode.id) {
                                        return {
                                          ...n,
                                          data: {
                                            ...n.data,
                                            imageUrl: instrumentImage.image
                                          }
                                        };
                                      }
                                      return n;
                                    })
                                  );
                                  // Update selectedNode immediately for real-time UI feedback
                                  setSelectedNode(prev => prev ? {
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      imageUrl: instrumentImage.image
                                    }
                                  } : null);
                                }}
                                sx={{
                                  width: '100%',
                                  height: 40,
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  border: `2px solid ${selectedNode.data.imageUrl === instrumentImage.image ? (theme.palette.brand?.royalBlue || theme.palette.primary.main) : theme.palette.divider}`,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                                  '&:hover': {
                                    borderColor: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  }
                                }}
                              >
                                <img
                                  src={instrumentImage.image}
                                  alt={instrumentImage.name}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#666',
                                    display: 'none',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  {instrumentImage.name}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}
                      
                      {/* Image Preview */}
                      {selectedNode.data.imageUrl && (
                        <Box
                          sx={{
                            width: '100%',
                            height: 120,
                            borderRadius: '8px',
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f5f5f5',
                            marginTop: 1
                          }}
                        >
                          <img
                            src={selectedNode.data.imageUrl}
                            alt="Preview"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              objectFit: 'contain'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#666',
                              display: 'none',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '100%'
                            }}
                          >
                            Invalid image URL
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Clear Image Button */}
                      {selectedNode.data.imageUrl && (
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setNodes((nds) =>
                              nds.map((n) => {
                                if (n.id === selectedNode.id) {
                                  return {
                                    ...n,
                                    data: {
                                      ...n.data,
                                      imageUrl: ''
                                    }
                                  };
                                }
                                return n;
                              })
                            );
                            // Update selectedNode immediately for real-time UI feedback
                            setSelectedNode(prev => prev ? {
                              ...prev,
                              data: {
                                ...prev.data,
                                imageUrl: ''
                              }
                            } : null);
                          }}
                          sx={{
                            fontSize: '0.7rem',
                            padding: '4px 8px',
                            minWidth: 'auto',
                            marginTop: 1
                          }}
                        >
                          Clear Image
                        </Button>
                      )}

                      {/* Node Size */}
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="caption" sx={{ 
                          color: '#666',
                          fontSize: '0.7rem',
                          fontWeight: 500,
                          display: 'block',
                          mb: 1
                        }}>
                          Node Size
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {nodeSizes.map((size) => {
                            const isSelected = selectedNode.data.nodeSize === size.value;
                            return (
                              <Button
                                key={size.value}
                                size="small"
                                variant={isSelected ? 'contained' : 'outlined'}
                                onClick={() => handleNodeSizeSelect(size.value)}
                                sx={{
                                  fontSize: '0.6rem',
                                  padding: '2px 6px',
                                  minWidth: 'auto',
                                backgroundColor: isSelected ? (theme.palette.brand?.gold || theme.palette.warning.main) : 'transparent',
                                color: isSelected ? '#fff' : (theme.palette.brand?.gold || theme.palette.warning.main),
                                borderColor: theme.palette.brand?.gold || theme.palette.warning.main,
                                fontWeight: isSelected ? 600 : 400,
                                '&:hover': {
                                  backgroundColor: isSelected 
                                    ? (theme.palette.mode === 'dark' ? alpha(theme.palette.brand?.gold || theme.palette.warning.main, 0.85) : alpha(theme.palette.brand?.gold || theme.palette.warning.main, 0.90))
                                    : alpha(theme.palette.brand?.gold || theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                                }
                                }}
                              >
                                {size.label}
                              </Button>
                            );
                          })}
                        </Box>
                      </Box>

                      {/* Color Picker */}
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="caption" sx={{ 
                          color: '#666',
                          fontSize: '0.7rem',
                          fontWeight: 500,
                          display: 'block',
                          mb: 1
                        }}>
                          Node Color
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {nodeColors.map((color) => (
                            <Box
                              key={color}
                              onClick={() => handleNodeColorSelect(color)}
                              sx={{
                                width: 24,
                                height: 24,
                                borderRadius: '4px',
                                backgroundColor: color,
                                border: `2px solid ${(selectedNode.data.nodeColor || (selectedNode.type === 'svg' ? '#9c27b0' : getStatusColor(selectedNode.data.status || 'Unknown'))) === color ? '#000' : 'transparent'}`,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  transform: 'scale(1.1)',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                }
                              }}
                            />
                          ))}
                        </Box>
                      </Box>

                      {/* Action Buttons */}
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setNodes((nds) => nds.filter((n) => n.id !== selectedNode.id));
                            setSelectedNode(null);
                          }}
                          sx={{
                            fontSize: '0.7rem',
                            padding: '4px 8px',
                            minWidth: 'auto'
                          }}
                        >
                          Delete
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => setSelectedNode(null)}
                          sx={{
                            fontSize: '0.7rem',
                            padding: '4px 8px',
                            minWidth: 'auto'
                          }}
                        >
                          Close
                        </Button>
                      </Stack>
                    </Stack>
                  </Stack>
                </Box>
              )}

              {/* Edit Edge Toolbar */}
              {selectedEdge && (
                <Box sx={{ 
                  padding: '16px 20px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.08)
                    : alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.05),
                  maxHeight: '300px',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[100],
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400],
                    borderRadius: '3px',
                    '&:hover': {
                      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[500],
                    },
                  },
                }}>
                  <Typography variant="subtitle2" sx={{ 
                    fontWeight: 600, 
                    mb: 2, 
                    color: theme.palette.brand?.jade || theme.palette.success.main,
                    fontSize: '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    Edit Edge
                  </Typography>
                  
                  <Stack spacing={2}>
                    {/* Edge Info */}
                    <Box sx={{ 
                      padding: '12px',
                      backgroundColor: theme.palette.background.paper,
                      borderRadius: '8px',
                      border: `1px solid ${alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.3)}`
                    }}>
                      <Typography variant="body2" sx={{ 
                        fontWeight: 600, 
                        color: theme.palette.brand?.jade || theme.palette.success.main,
                        fontSize: '0.8rem',
                        mb: 1
                      }}>
                        Connection
                      </Typography>
                      <Typography variant="caption" sx={{ 
                        color: theme.palette.text.secondary,
                        fontSize: '0.7rem'
                      }}>
                        From: {selectedEdge.source} • To: {selectedEdge.target} • ID: {selectedEdge.id}
                      </Typography>
                    </Box>

                    {/* Edge Color */}
                    <Box>
                      <Typography variant="caption" sx={{ 
                        color: '#666',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        display: 'block',
                        mb: 1
                      }}>
                        Edge Color
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {edgeColors.map((color) => (
                          <Box
                            key={color}
                            onClick={() => handleEdgeColorSelect(color)}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: '4px',
                              backgroundColor: color,
                              border: `2px solid ${(selectedEdge.style?.stroke || '#b1b1b7') === color ? '#000' : 'transparent'}`,
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                transform: 'scale(1.1)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                              }
                            }}
                          />
                        ))}
                      </Box>
                    </Box>

                    {/* Edge Style */}
                    <Box>
                      <Typography variant="caption" sx={{ 
                        color: '#666',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        display: 'block',
                        mb: 1
                      }}>
                        Edge Style
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {edgeStyles.map((style) => {
                          const isSelected = selectedEdge.style?.strokeDasharray === 
                            (style.value === 'solid' ? undefined : 
                             style.value === 'dashed' ? '5,5' : 
                             style.value === 'dotted' ? '2,2' : 
                             style.value === 'double' ? '0,10' : undefined);
                          return (
                            <Button
                              key={style.value}
                              size="small"
                              variant={isSelected ? 'contained' : 'outlined'}
                              onClick={() => handleEdgeStyleSelect(style.value)}
                              sx={{
                                fontSize: '0.6rem',
                                padding: '2px 6px',
                                minWidth: 'auto',
                                backgroundColor: isSelected ? (theme.palette.brand?.jade || theme.palette.success.main) : 'transparent',
                                color: isSelected ? '#fff' : (theme.palette.brand?.jade || theme.palette.success.main),
                                borderColor: theme.palette.brand?.jade || theme.palette.success.main,
                                fontWeight: isSelected ? 600 : 400,
                                '&:hover': {
                                  backgroundColor: isSelected 
                                    ? (theme.palette.mode === 'dark' ? alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.85) : alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.90))
                                    : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                                }
                              }}
                            >
                              {style.label}
                            </Button>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* Edge Thickness */}
                    <Box>
                      <Typography variant="caption" sx={{ 
                        color: '#666',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        display: 'block',
                        mb: 1
                      }}>
                        Edge Thickness
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {edgeThicknesses.map((thickness) => {
                          const isSelected = selectedEdge.style?.strokeWidth === thickness.value;
                          return (
                            <Button
                              key={thickness.value}
                              size="small"
                              variant={isSelected ? 'contained' : 'outlined'}
                              onClick={() => handleEdgeThicknessSelect(thickness.value)}
                              sx={{
                                fontSize: '0.6rem',
                                padding: '2px 6px',
                                minWidth: 'auto',
                                backgroundColor: isSelected ? (theme.palette.brand?.jade || theme.palette.success.main) : 'transparent',
                                color: isSelected ? '#fff' : (theme.palette.brand?.jade || theme.palette.success.main),
                                borderColor: theme.palette.brand?.jade || theme.palette.success.main,
                                fontWeight: isSelected ? 600 : 400,
                                '&:hover': {
                                  backgroundColor: isSelected 
                                    ? (theme.palette.mode === 'dark' ? alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.85) : alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.90))
                                    : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                                }
                              }}
                            >
                              {thickness.label}
                            </Button>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* Edge Path Type */}
                    <Box>
                      <Typography variant="caption" sx={{ 
                        color: '#666',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        display: 'block',
                        mb: 1
                      }}>
                        Path Type
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {edgePathTypes.map((pathType) => {
                          const isSelected = selectedEdge.type === pathType.value;
                          return (
                            <Button
                              key={pathType.value}
                              size="small"
                              variant={isSelected ? 'contained' : 'outlined'}
                              onClick={() => handleEdgePathTypeSelect(pathType.value)}
                              sx={{
                                fontSize: '0.6rem',
                                padding: '2px 6px',
                                minWidth: 'auto',
                                backgroundColor: isSelected ? (theme.palette.brand?.jade || theme.palette.success.main) : 'transparent',
                                color: isSelected ? '#fff' : (theme.palette.brand?.jade || theme.palette.success.main),
                                borderColor: theme.palette.brand?.jade || theme.palette.success.main,
                                fontWeight: isSelected ? 600 : 400,
                                '&:hover': {
                                  backgroundColor: isSelected 
                                    ? (theme.palette.mode === 'dark' ? alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.85) : alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.90))
                                    : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                                }
                              }}
                            >
                              {pathType.label}
                            </Button>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* Edge Animation */}
                    <Box>
                      <Typography variant="caption" sx={{ 
                        color: '#666',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        display: 'block',
                        mb: 1
                      }}>
                        Animation
                      </Typography>
                      <Button
                        size="small"
                        variant={selectedEdge.animated ? 'contained' : 'outlined'}
                        onClick={handleEdgeAnimationToggle}
                        sx={{
                          fontSize: '0.7rem',
                          padding: '4px 8px',
                          minWidth: 'auto',
                          backgroundColor: selectedEdge.animated ? (theme.palette.brand?.jade || theme.palette.success.main) : 'transparent',
                          color: selectedEdge.animated ? '#fff' : (theme.palette.brand?.jade || theme.palette.success.main),
                          borderColor: theme.palette.brand?.jade || theme.palette.success.main,
                          fontWeight: selectedEdge.animated ? 600 : 400,
                          '&:hover': {
                            backgroundColor: selectedEdge.animated 
                              ? (theme.palette.mode === 'dark' ? alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.85) : alpha(theme.palette.brand?.jade || theme.palette.success.main, 0.90))
                              : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                          }
                        }}
                      >
                        {selectedEdge.animated ? 'Animated' : 'Static'}
                      </Button>
                    </Box>

                    {/* Action Buttons */}
                    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          setEdges((eds) => eds.filter((e) => e.id !== selectedEdge.id));
                          setSelectedEdge(null);
                        }}
                        sx={{
                          fontSize: '0.7rem',
                          padding: '4px 8px',
                          minWidth: 'auto'
                        }}
                      >
                        Delete
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => setSelectedEdge(null)}
                        sx={{
                          fontSize: '0.7rem',
                          padding: '4px 8px',
                          minWidth: 'auto'
                        }}
                      >
                        Close
                      </Button>
                    </Stack>
                  </Stack>
                </Box>
              )}

              {/* Equipment Categories */}
              <Box sx={{ 
                flex: 1, 
                padding: '16px 20px',
                paddingTop: '20px',
                overflowY: 'auto'
              }}>
                <Stack spacing={3}>
                  {/* Database Equipment by Category */}
                  {equipmentData.length > 0 && (
                    <Box>
                      <Typography variant="subtitle2" sx={{ 
                        fontWeight: 600, 
                        mb: 2, 
                        color: theme.palette.brand?.jade || theme.palette.success.main,
                        fontSize: '0.8rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        Database Equipment ({equipmentData.length})
                      </Typography>
                      
                      {Object.entries(equipmentByCategory).map(([category, equipment]) => (
                        <Accordion 
                          key={category}
                          sx={{ 
                            mb: 1,
                            '&:before': { display: 'none' },
                            boxShadow: 'none',
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: '8px',
                            backgroundColor: theme.palette.background.paper,
                            '&.Mui-expanded': {
                              margin: '8px 0'
                            }
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMore sx={{ color: theme.palette.text.secondary }} />}
                            sx={{
                              backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.5) : theme.palette.grey[50],
                              borderRadius: '8px',
                              '&:hover': {
                                backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.7) : theme.palette.grey[100]
                              },
                              '& .MuiAccordionSummary-content': {
                                margin: '8px 0'
                              }
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Box
                                sx={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: '50%',
                                  backgroundColor: (() => {
                                    switch (category) {
                                      case 'Instruments': return '#2196F3';
                                      case 'Pumps': return '#FF9800';
                                      case 'Blowers': return '#9C27B0';
                                      case 'Belts & Screens': return '#795548';
                                      case 'Agitators & Mixers': return '#607D8B';
                                      case 'Dosing Pumps': return '#E91E63';
                                      case 'Switches': return '#3F51B5';
                                      case 'Valves': return '#009688';
                                      default: return '#666666';
                                    }
                                  })(),
                                  flexShrink: 0
                                }}
                              />
                              <Typography variant="body2" sx={{ 
                                fontWeight: 600, 
                                color: theme.palette.text.primary,
                                fontSize: '0.8rem'
                              }}>
                                {category}
                              </Typography>
                              <Chip 
                                label={equipment.length} 
                                size="small" 
                                sx={{ 
                                  backgroundColor: alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.10),
                                  color: theme.palette.brand?.royalBlue || theme.palette.primary.main,
                                  fontSize: '0.6rem',
                                  height: 20,
                                  minWidth: 20
                                }}
                              />
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails sx={{ padding: '8px 16px 16px' }}>
                            <Stack spacing={1}>
                              {equipment.map((node) => {
                                const isPlaced = isEquipmentPlaced(node.id);
                                return (
                                  <Box
                                    key={node.id}
                                    draggable={!isPlaced}
                                    onDragStart={!isPlaced ? (event) => {
                                      event.dataTransfer.setData('application/reactflow', JSON.stringify({
                                        type: 'node',
                                        nodeType: 'equipment',
                                        data: {
                                          label: node.data.label,
                                          type: node.data.type,
                                          status: node.data.status,
                                          equipment: node.data.equipment,
                                          category: node.data.category
                                        }
                                      }));
                                    } : undefined}
                                    sx={{
                                      padding: '8px 10px',
                                      backgroundColor: isPlaced 
                                        ? (theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.3) : theme.palette.grey[100])
                                        : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.08 : 0.05),
                                      borderRadius: '6px',
                                      cursor: isPlaced ? 'not-allowed' : 'grab',
                                      border: isPlaced 
                                        ? `1px solid ${theme.palette.divider}` 
                                        : `1px solid ${theme.palette.brand?.jade || theme.palette.success.main}`,
                                      transition: 'all 0.2s ease',
                                      opacity: isPlaced ? 0.6 : 1,
                                      position: 'relative',
                                      '&:hover': {
                                        backgroundColor: isPlaced 
                                          ? (theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.3) : theme.palette.grey[100])
                                          : alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.12 : 0.08),
                                        borderColor: isPlaced ? theme.palette.divider : (theme.palette.brand?.jade || theme.palette.success.main),
                                        transform: isPlaced ? 'none' : 'translateY(-1px)',
                                        boxShadow: isPlaced ? 'none' : (theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(76, 175, 80, 0.15)'),
                                      },
                                      '&:active': {
                                        cursor: isPlaced ? 'not-allowed' : 'grabbing',
                                        transform: isPlaced ? 'none' : 'translateY(0px)',
                                      }
                                    }}
                                  >
                                    {isPlaced && (
                                      <Box
                                        sx={{
                                          position: 'absolute',
                                          top: 2,
                                          right: 2,
                                          width: 8,
                                          height: 8,
                                          borderRadius: '50%',
                                          backgroundColor: theme.palette.brand?.jade || theme.palette.success.main,
                                          border: `1px solid ${theme.palette.background.paper}`
                                        }}
                                      />
                                    )}
                                    <Typography variant="body2" sx={{ 
                                      fontWeight: 600, 
                                      color: isPlaced ? theme.palette.text.disabled : (theme.palette.brand?.jade || theme.palette.success.main),
                                      fontSize: '0.75rem',
                                      mb: 0.5,
                                      lineHeight: 1.2,
                                      textDecoration: isPlaced ? 'line-through' : 'none'
                                    }}>
                                      {node.data.label}
                                    </Typography>
                                    <Typography variant="caption" sx={{ 
                                      color: isPlaced ? theme.palette.text.disabled : theme.palette.text.secondary,
                                      fontSize: '0.65rem'
                                    }}>
                                      {node.data.type}
                                    </Typography>
                                    {isPlaced && (
                                      <Typography variant="caption" sx={{ 
                                        color: theme.palette.brand?.jade || theme.palette.success.main,
                                        fontSize: '0.6rem',
                                        fontWeight: 600,
                                        display: 'block',
                                        mt: 0.5
                                      }}>
                                        ✓ Placed
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              })}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  )}


                </Stack>
              </Box>
            </Box>
          )}

          <Box sx={{ flex: 1, position: 'relative' }}>
            <ReactFlowProvider>
              <ReactFlow
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={isEditMode ? onConnect : undefined}
                onNodeDragStop={isEditMode ? onNodeDragStop : undefined}
                onNodesDelete={isEditMode ? onNodesDelete : undefined}
                onEdgesDelete={isEditMode ? onEdgesDelete : undefined}
                onDragOver={isEditMode ? onDragOver : undefined}
                onDrop={isEditMode ? onDrop : undefined}
                onNodeClick={onNodeClick}
                onEdgeClick={onEdgeClick}
                onPaneClick={onPaneClick}
                onInit={setReactFlowInstance}
                nodeTypes={nodeTypes}
                fitView
                attributionPosition="bottom-left"
                style={{ backgroundColor: theme.palette.background.default }}
                nodesDraggable={isEditMode}
                nodesConnectable={isEditMode}
                elementsSelectable={isEditMode}
              >
                <Controls />
                <MiniMap 
                  nodeStrokeColor={(n) => {
                    if (n.type === 'input') return theme.palette.brand?.royalBlue || theme.palette.primary.main;
                    if (n.type === 'output') return theme.palette.accents?.rose || theme.palette.error.main;
                    return theme.palette.text.primary;
                  }}
                  nodeColor={(n) => {
                    if (n.style?.background) return n.style.background;
                    return theme.palette.background.paper;
                  }}
                  nodeBorderRadius={2}
                  style={{ backgroundColor: theme.palette.background.paper }}
                />
                <Background 
                  variant="dots" 
                  gap={12} 
                  size={1} 
                  color={theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[300]}
                />
                
                {/* Empty Canvas Message */}
                {nodes.length === 0 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      padding: 4,
                      borderRadius: 3,
                      boxShadow: theme.palette.mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.4)' : '0 8px 32px rgba(0,0,0,0.1)',
                      border: `2px dashed ${theme.palette.divider}`,
                      maxWidth: 450,
                      backdropFilter: 'blur(10px)'
                    }}
                  >
                    <Typography variant="h5" sx={{ color: theme.palette.brand?.royalBlue || theme.palette.primary.main, mb: 2, fontWeight: 600 }}>
                      🏭 Plant Canvas
                    </Typography>
                    <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 3, lineHeight: 1.6 }}>
                      Start building your plant layout by dragging equipment from the database
                    </Typography>
                    
                    {!isEditMode ? (
                      <Box sx={{ 
                        backgroundColor: alpha(theme.palette.brand?.royalBlue || theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.10), 
                        padding: 2, 
                        borderRadius: 2, 
                        border: `1px solid ${theme.palette.brand?.royalBlue || theme.palette.primary.main}` 
                      }}>
                        <Typography variant="body2" sx={{ color: theme.palette.brand?.royalBlue || theme.palette.primary.main, fontWeight: 500 }}>
                          💡 Switch to Edit Mode to access the equipment palette
                        </Typography>
                      </Box>
                    ) : (
                      <Box sx={{ 
                        backgroundColor: alpha(theme.palette.brand?.jade || theme.palette.success.main, theme.palette.mode === 'dark' ? 0.16 : 0.10), 
                        padding: 2, 
                        borderRadius: 2, 
                        border: `1px solid ${theme.palette.brand?.jade || theme.palette.success.main}` 
                      }}>
                        <Typography variant="body2" sx={{ color: theme.palette.brand?.jade || theme.palette.success.main, fontWeight: 500 }}>
                          ✅ Equipment palette is available on the left side
                        </Typography>
                      </Box>
                    )}
                    
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        🎯 Drag equipment to canvas
                      </Typography>
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        🔗 Connect with edges
                      </Typography>
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        💾 Save your layout
                      </Typography>
                    </Box>
                  </Box>
                )}
              </ReactFlow>
            </ReactFlowProvider>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PlantView; 